import React, { useEffect, useState } from "react";
import { useIsFocused, useNavigation, useRoute } from "@react-navigation/native";
import HelperValidate from "utils/helper-validate";
import i18n from "utils/i18n";
import _ from "lodash";
import { FormStatus } from 'utils/constants/form-constants';
import GraphqlBuilder from "utils/request/graphql/builder";
import QueryManagementBuilding from "graphql/queries/management/QueryManagementBuilding";
import MutationManagementBuilding from "graphql/mutations/management/MutationManagementBuilding";
import ThemedSafeAreaComponentTop from "components/atoms/ThemedSafeAreaTop";
import ThemedLayout from "components/atoms/ThemedLayout";
import LoadingComponent from "components/atoms/Loading";
import Translate from "utils/translate";
import { tableConstants } from "utils/constants/constants";
import HelperString from 'utils/helper-string'
import MutateTranslation from 'utils/mutate/translation'
import ObjectBuilding from 'utils/objects/building'
import HelperAvailability from "utils/helper/HelperAvailability";
import ManagementBuildingsComponentsTeamsScene from "./components/teams";
import ManagementBuildingsComponentsEmployeeScene from "./components/employees";
import ManagementBuildingsComponentsTimeslotsScene from "./components/timeslots";
import ObjectTimeslot from "utils/objects/timeslot";
import HelperManagementRights from "utils/helper-management-rights";
import { managementRightsConstants } from "utils/constants/management-right-constants";
import TabbedContent from 'components/molecules/TabbedContent'
import BuildingStatistics from 'scenes/management/buildings/components/building/statistics'
import BuildingData from 'scenes/management/buildings/components/building/data'
import BuildingFloors from 'scenes/management/buildings/components/building/floors'
import BuildingContact from 'scenes/management/buildings/components/building/contact'
import { AppRoutes } from 'navigations/app-routes'
import BuildingLunch from 'scenes/management/buildings/components/building/lunch'
import ManagementBuildingsComponentsTimeslotExceptionsScene from 'scenes/management/buildings/components/timeslotsExceptions'

const ManagementBuildingBuildingScene = ({  }) => {

	const viewTabs = {
		DATA: 'data',
		FLOORS: 'floors',
		STATISTICS: 'statistics',
		TIMESLOTS: 'timeslots',
		TIMESLOT_EXCEPTIONS: 'timeslot_exceptions',
		LUNCH: 'lunch',
		CONTACT_PERSONS: 'contact_persons',
		AVAILABLE_FOR_EMPLOYEES: 'available_for_employees',
		AVAILABLE_FOR_TEAMS: 'available_for_teams',
	};
	
	const isFocused = useIsFocused();
	const navigation = useNavigation();
	const route = useRoute();
	
	const [ loading, setLoading ] = useState( true )
	const [ building, setBuilding ] = useState( {} )
	const [ addedAvailableForEmployees, setAddedAvailableForEmployees ] = useState( [] )
	const [ addedAvailableForTeams, setAddedAvailableForTeams ] = useState( [] )
	
	const buildingGuid = _.get( route.params, 'buildingGuid', null )
	
	const renderTabs = () => {
		const tabBarItems = [];
		
		const buildingExists = _.get( building, 'guid', null ) !== null;
		
		if( buildingExists ) {
			tabBarItems.push( {
				key: viewTabs.STATISTICS,
				text: i18n.t( 'management:form_block.title_statistic_other' ),
				scene: ( props ) => {
					return (
						<BuildingStatistics
							building={ building }
						/>
					);
				}
			} );
		}
		
		tabBarItems.push( {
			key: viewTabs.DATA,
			text: i18n.t( 'management:form_block.title_default' ),
			scene: ( props ) => {
				return (
					<BuildingData
						building={ building }
						saveForm={ saveForm }
					/>
				);
			}
		});
		
		if( buildingExists ) {
			const buildingGroupedTimeslots = ObjectTimeslot.groupTimeSlots( building, {
				parse: true,
				disableKindBooking: ObjectBuilding.hasFloors( building )
			} )
			
			if( HelperManagementRights.hasViewRight( managementRightsConstants.VIEW.BUILDING_TIMESLOTS ) ) {
				
				tabBarItems.push( {
					key: viewTabs.TIMESLOTS,
					text: HelperString.addArrayLength( i18n.t( 'management:form_block.title_timeslot' ), buildingGroupedTimeslots, false ),
					scene: ( props ) => {
						return (
							<ManagementBuildingsComponentsTimeslotsScene
									building={ building }
									onSubmit={ fetchBuilding }
									readonly={ !HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.BUILDING_TIMESLOTS ) }
								/>
						);
					}
				} );
				
				tabBarItems.push( {
					key: viewTabs.TIMESLOT_EXCEPTIONS,
					text: HelperString.addArrayLength( i18n.t( 'management:form_block.title_timeslot_exceptions' ) ),
					scene: ( props ) => {
						return (
							<ManagementBuildingsComponentsTimeslotExceptionsScene
									building={ building }
									onSubmit={ fetchBuilding }
									readonly={ !HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.BUILDING_TIMESLOTS ) }
								/>
						);
					}
				} );
			}
			
			
			tabBarItems.push({
				key: viewTabs.LUNCH,
				text: i18n.t( 'management:form_block.title_lunch' ),
				scene: ( props ) => {
					return (
						<BuildingLunch
							building={ building }
						/>
					);
				}}
			);
			
			if( HelperManagementRights.hasViewRight( managementRightsConstants.VIEW.BUILDING_TEAMS_EMPLOYEES ) ) {
				if ( building.available_for === HelperAvailability.AVAILABLE_FOR_RESTRICTED ) {
					tabBarItems.push( {
						key: viewTabs.AVAILABLE_FOR_TEAMS,
						text: HelperString.addArrayLength( i18n.t( 'management:form_block.title_available_for_teams' ), addedAvailableForTeams, false ),
						scene: ( props ) => {
							return (
								<ManagementBuildingsComponentsTeamsScene
									building={ building }
									addedAvailableForTeams={ addedAvailableForTeams }
									onSubmit={ fetchBuilding }
									readonly={ !HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.BUILDING_TEAMS_EMPLOYEES ) }
								/>
							);
						}
					})
				}
				
				if ( building.available_for === HelperAvailability.AVAILABLE_FOR_RESTRICTED_EMPLOYEES ) {
					tabBarItems.push( {
						key: viewTabs.AVAILABLE_FOR_EMPLOYEES,
						text: HelperString.addArrayLength( i18n.t( 'management:form_block.title_available_for_employees' ), addedAvailableForEmployees, false ),
						scene: ( props ) => {
							return (
								<ManagementBuildingsComponentsEmployeeScene
									building={ building }
									addedAvailableForEmployees={ addedAvailableForEmployees }
									onSubmit={ fetchBuilding }
									readonly={ !HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.BUILDING_TEAMS_EMPLOYEES ) }
								/>
							);
						}
					})
				}
			}
			
			if( HelperManagementRights.hasViewRight( managementRightsConstants.VIEW.BUILDING_CONTACT_PERSONS ) ) {
				tabBarItems.push( {
					key: viewTabs.CONTACT_PERSONS,
					text: HelperString.addArrayLength( i18n.t('management:form_block.title_contact_persons' ), _.get( building, 'contacts', [] ), false ),
					scene: ( props ) => {
						return (
							<BuildingContact
								building={ building }
							/>
						);
					}
				})
			}
			
			if( HelperManagementRights.hasViewRight( managementRightsConstants.VIEW.FLOORS ) ) {
				tabBarItems.push( {
					key: viewTabs.FLOORS,
					text: HelperString.addArrayLength( i18n.t('management:form_block.title_floor_other' ), _.get( building, 'floors', [] ), false ),
					scene: ( props ) => {
						return (
							<BuildingFloors
								building={ building }
							/>
						);
					}
				})
			}
		}
		
		return (
			<TabbedContent
				items={ tabBarItems }
			/>
		)
	}
	
	const fetchBuilding = () => {
		if( HelperValidate.isValid( buildingGuid ) && !_.isEmpty( buildingGuid ) ) {
			new GraphqlBuilder()
				.addQuery( 'query', QueryManagementBuilding, {
					guid: buildingGuid
				})
				.setResultPath( ['query', 'building'], {} )
				.setOnSuccess( result => {
					const addedAvailableForEmployees = [];
					_.get( result, ['available_for_employees' ], [] ).forEach( ( employee ) => {
						addedAvailableForEmployees.push( employee.employee );
					});
					
					const addedAvailableForTeams = [];
					_.get( result, ['available_for_teams' ], [] ).forEach( ( team ) => {
						if( team.team !== null ) {
							addedAvailableForTeams.push( team.team );
						}
					});
					
					setAddedAvailableForEmployees( addedAvailableForEmployees )
					setAddedAvailableForTeams( addedAvailableForTeams )
					setBuilding( result )
					setLoading( false )
				})
				.setOnError( setLoading.bind( this, false ) )
				.execute()
			
			return;
		}
		
		setBuilding( ObjectBuilding.defaults )
		setLoading( false )
	}
	
	const saveForm = ( values, { callback } = {} ) => {
		new GraphqlBuilder()
			.addQuery( 'mutation', MutationManagementBuilding, values )
			.setResultPath( ['mutation', 'building'], {} )
			.setOnStart( () => {
				callback( FormStatus.LOADING )
			})
			.setOnSuccess( ( result ) => {
				MutateTranslation.mutate( tableConstants.BUILDINGS, result.guid, values, {
					callbackSuccess: ( t ) => {
						callback( FormStatus.SUCCESS )

						navigation.replace( AppRoutes.MANAGEMENT_BUILDINGS_BUILDINGS_VIEW, {
							buildingGuid: result.guid,
						});
					},
					callbackError: () => {
						callback( FormStatus.ERROR )
					}
				} )
			})
			.setOnError( ( result ) => {
				callback( FormStatus.ERROR )
			})
			.execute()
	}
	
	useEffect( fetchBuilding, [ isFocused, buildingGuid ] )
	
	let content = <LoadingComponent />
	if( !loading ) {
		content = renderTabs()
	}
	
	return (
		<ThemedSafeAreaComponentTop
			top={ false }>
			
			<ThemedLayout
				topNavigation={true}
				topNavigationProps={{
					showBackButton: true
				}}
				title={ i18n.t('management:pages.buildings.building.title', {
					name: Translate.field( building, 'name' ),
					interpolation: {
						escapeValue: false
					}
				})}>
				
				{ content }
			</ThemedLayout>
		</ThemedSafeAreaComponentTop>
	);
}

export default ManagementBuildingBuildingScene
